export const YANDEX_MAPS_API_KEY = "1be71b9b-1bc9-47c4-bb72-a6acd502cc6d";
